import generatePalette from './generate-palette';
import constants from '../constants';
import converters from '../converters';
import HSLColor from '../classes/hsl-color';

const { GOLDEN_PALETTES, TOLERANCE } = constants;
const generateLightPalette = (hslColor) => {
  const { hsl2rgb } = converters;
  return {
    0: new HSLColor(0, 0, 1),
    ...generatePalette(
      hsl2rgb(hslColor),
      GOLDEN_PALETTES.LIGHT,
      TOLERANCE.DEFAULT_LIGHTNESS,
      TOLERANCE.REDUCED_CHROMA
    ),
  };
};
export default generateLightPalette;
